﻿export interface IProduct {
    id: number,
    name: string,
    alias: string,
    owner: string,
    property: string,
    isActive: boolean
}
